import React, { useState } from 'react';
import { Modal } from 'antd';
import { Candle2Icon } from 'icons';
import { useTranslations } from 'next-intl';

import SortsSelect from './sorts-select';

const FilterModal = () => {
  const t = useTranslations();
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        onClick={() => setOpen(true)}
        className="flex size-9 cursor-pointer items-center justify-center rounded-full bg-white sm:hidden"
      >
        <Candle2Icon />
      </div>

      <Modal
        footer={false}
        open={open}
        centered
        onCancel={() => setOpen(false)}
        width="421px"
        closeIcon={false}
        styles={{
          content: { padding: '16px', borderRadius: '12px' }
        }}
        title={<span className="text-lg">{t('kurslarni_saralash')}</span>}
      >
        <SortsSelect maxVisibleTags={5} dropDownClassName="w-full" selectClassName="!w-full !bg-gray-100 !mb-3 !py-3" />
      </Modal>
    </>
  );
};

export default FilterModal;
